import { useGlobal } from "@/app/providers/use-global";
import { Check } from "lucide-react";

export const VoiceSettings = () => {
  const {
    selectedEnglishTtsVoice,
    setSelectedEnglishTtsVoice,
    selectedArabicTtsVoice,
    setSelectedArabicTtsVoice,
    ttsSource,
  } = useGlobal();

  const handleVoiceChange = (voice: string) => {
    if (ttsSource === "english" || ttsSource === "mute") {
      setSelectedEnglishTtsVoice(voice);
    } else {
      setSelectedArabicTtsVoice(voice);
    }
  };

  return (
    <>
      {(ttsSource === "english" || ttsSource === "mute") && (
        <>
          <button
            className="w-full text-sm flex items-center px-6 py-1.5 hover:bg-accent dark:hover:bg-neutral-700 rounded-sm"
            type="button"
            onClick={() => handleVoiceChange("Basil-PlayAI")}
          >
            {selectedEnglishTtsVoice === "Basil-PlayAI" ? (
              <Check className="w-4 h-4 mr-2" />
            ) : (
              <div className="w-4 h-4 mr-2" />
            )}
            Basil
          </button>
          <button
            className="w-full text-sm flex items-center px-6 py-1.5 hover:bg-accent dark:hover:bg-neutral-700 rounded-sm"
            type="button"
            onClick={() => handleVoiceChange("Cheyenne-PlayAI")}
          >
            {selectedEnglishTtsVoice === "Cheyenne-PlayAI" ? (
              <Check className="w-4 h-4 mr-2" />
            ) : (
              <div className="w-4 h-4 mr-2" />
            )}
            Cheyenne
          </button>
          <button
            className="w-full text-sm flex items-center px-6 py-1.5 hover:bg-accent dark:hover:bg-neutral-700 rounded-sm"
            type="button"
            onClick={() => handleVoiceChange("Mikail-PlayAI")}
          >
            {selectedEnglishTtsVoice === "Mikail-PlayAI" ? (
              <Check className="w-4 h-4 mr-2" />
            ) : (
              <div className="w-4 h-4 mr-2" />
            )}
            Mikail
          </button>
          <button
            className="w-full text-sm flex items-center px-6 py-1.5 hover:bg-accent dark:hover:bg-neutral-700 rounded-sm"
            type="button"
            onClick={() => handleVoiceChange("Quinn-PlayAI")}
          >
            {selectedEnglishTtsVoice === "Quinn-PlayAI" ? (
              <Check className="w-4 h-4 mr-2" />
            ) : (
              <div className="w-4 h-4 mr-2" />
            )}
            Quinn
          </button>
        </>
      )}
      {ttsSource === "arabic" && (
        <>
          <button
            className="w-full text-sm flex items-center px-6 py-1.5 hover:bg-accent dark:hover:bg-neutral-700 rounded-sm"
            type="button"
            onClick={() => handleVoiceChange("Nasser-PlayAI")}
          >
            {selectedArabicTtsVoice === "Nasser-PlayAI" ? (
              <Check className="w-4 h-4 mr-2" />
            ) : (
              <div className="w-4 h-4 mr-2" />
            )}
            Nasser
          </button>
          <button
            className="w-full text-sm flex items-center px-6 py-1.5 hover:bg-accent dark:hover:bg-neutral-700 rounded-sm"
            type="button"
            onClick={() => handleVoiceChange("Khalid-PlayAI")}
          >
            {selectedArabicTtsVoice === "Khalid-PlayAI" ? (
              <Check className="w-4 h-4 mr-2" />
            ) : (
              <div className="w-4 h-4 mr-2" />
            )}
            Khalid
          </button>
          <button
            className="w-full text-sm flex items-center px-6 py-1.5 hover:bg-accent dark:hover:bg-neutral-700 rounded-sm"
            type="button"
            onClick={() => handleVoiceChange("Amira-PlayAI")}
          >
            {selectedArabicTtsVoice === "Amira-PlayAI" ? (
              <Check className="w-4 h-4 mr-2" />
            ) : (
              <div className="w-4 h-4 mr-2" />
            )}
            Amira
          </button>
          <button
            className="w-full text-sm flex items-center px-6 py-1.5 hover:bg-accent dark:hover:bg-neutral-700 rounded-sm"
            type="button"
            onClick={() => handleVoiceChange("Ahmad-PlayAI")}
          >
            {selectedArabicTtsVoice === "Ahmad-PlayAI" ? (
              <Check className="w-4 h-4 mr-2" />
            ) : (
              <div className="w-4 h-4 mr-2" />
            )}
            Ahmad
          </button>
        </>
      )}
    </>
  );
};
